import React from "react";

const ShippingPolicy = () => {
  return (
    <div className="shipping-policy-area space">
      <div className="container">
        <h2 className="mb-4">Shipping Policy</h2>
        <p>
          Gowrisankar Agencies ensures reliable delivery of auto parts across India. Below are our shipping terms.
        </p>

        <h4>1. Delivery Timelines</h4>
        <p>
          Orders are processed within 1–2 business days. Estimated delivery takes 5–10 business days depending on the location.
        </p>

        <h4>2. Shipping Charges</h4>
        <p>
          Shipping charges vary based on weight, size, and delivery location. Charges will be displayed during checkout.
        </p>

        <h4>3. Tracking Orders</h4>
        <p>
          Once your order is shipped, you’ll receive a tracking ID to monitor the delivery status.
        </p>

        <h4>4. Delays</h4>
        <p>
          While we aim for timely delivery, delays may occur due to logistics or weather. We appreciate your patience.
        </p>

        <h4>5. Contact</h4>
        <p>
          For shipping-related questions, email us at <a href="mailto:rajesh.katakam@gmail.com">rajesh.katakam@gmail.com</a> or call <a href="tel:09248022760">092480 22760</a>.
        </p>
      </div>
    </div>
  );
};

export default ShippingPolicy;
